// 1 => '一', 2 =>'二', 3 => '三', 4 => '四' 直到 10 => '十'
export const cnStepMap = {
    1: '一',
    2: '二',
    3: '三',
    4: '四',
    5: '五',
    6: '六',
    7: '七',
    8: '八',
    9: '九',
    10: '十',
}

// 祖先屋源最新的合約範本Template
export const newstContractTemplate = {
    personalTraditionalPaper: 'personal_traditional_paper',
    juridicalPersonTraditionalPaper: 'juridical_person_traditional_paper',
    personalEasyCustom: 'personal_easy_custom',
    juridicalPersonEasyCustomContract: 'juridical_person_easy_custom_contract',
}
